import { type FulfillmentApi } from '@entities/fulfillment'

/**
 * Пороги объёма, с которых начинается очередная ступень цены.
 *
 * Числа временно наши. Сервер проверяет пороги по своей настройке и отклоняет чужие значения, но
 * маршрута, отдающего эту настройку, у него нет — попросили завести, пока ждём. Значит при
 * изменении настройки на сервере форма начнёт предлагать пороги, которые он не примет, и владелец
 * получит непонятный отказ. Это известный размен, а не недосмотр.
 *
 * У схемы «другое» лестницы не бывает: сервер принимает там только пустой список.
 */
const volumeStepsByShipmentType: Record<FulfillmentApi.ShipmentType, number[]> = {
  fbo: [100, 500, 1000, 5000, 10000],
  fbs: [10, 50, 100, 500],
  dbs: [10, 50, 100, 500],
  other: [],
}

/**
 * Какие пороги можно выбрать в этой карточке.
 *
 * Шире сетки намеренно: порог, выбывший из настройки сервера, остаётся допустимым там, где на нём
 * уже сохранена цена — изменить её можно, завести новую цену на выбывшем пороге нельзя. Если брать
 * одну только сетку, владелец увидит собственную сохранённую цену как недопустимую.
 */
export const availableVolumeSteps = (shipmentType: FulfillmentApi.ShipmentType, savedSteps: number[] = []) =>
  Array.from(new Set([...volumeStepsByShipmentType[shipmentType], ...savedSteps])).sort((one, other) => one - other)
